import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineMenu, AiFillCloseCircle } from "react-icons/ai";

const NavBar = () => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <nav className=" bg-red-400 py-4  ">
        <div className=" inline-block  w-4/5 md:w-1/5">
          <h1 className="text-2xl ">NAV_LOGO </h1>
        </div>
        <div
          className="inline-block md:hidden "
          onClick={() => setOpen((prev) => !prev)}
        >
          {open ? (
            <AiFillCloseCircle className="text-blue-500" size={26} />
          ) : (
            <AiOutlineMenu />
          )}
        </div>
        <div className="hidden md:inline-block ml-64 space-x-4 ">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Conatct</Link>
        </div>
      </nav>
      <div>
        {open ? (
          <>
            <ul className="bg-red-300">
              <Link to="/">
                <li>home</li>
              </Link>
              <Link to="/about">
                <li>About</li>
              </Link>
              <Link to="/contact">
                <li>Conatct</li>
              </Link>
            </ul>
          </>
        ) : (
          <h1>closed</h1>
        )}
      </div>
    </div>
  );
};

export default NavBar;

{
  /*       
      <Link to="/">Home</Link>
      <Link to="/about">About</Link>
      <Link to="/contact">Conatact</Link> */
}
